import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { StyledContainer } from '@/ui-components/atoms/Layout/StyledContainer/StyledContainer';
import { Text } from '@/ui-components/atoms/Text/Text';
import { RenderRTE } from '@/components-2.0/structure/RenderRTE';

interface Props {
    sweepsFields: Pick<SiteSweeps['fields'], 'closed_description' | 'closed_headline' | 'closed_message'>;
    asW2?: boolean;
}

export default function Ended({ sweepsFields, asW2 }: Props) {
    return (
        <Grid container>
            <Grid col={{ sm: 12, lg: 10 }} start={{ lg: 2 }}>
                <StyledContainer paddingTop={40} paddingBottom={40}>
                    <Text tag="h2" variant="h2" style={{ marginBottom: 30 }}>
                        {sweepsFields.closed_headline || 'Sorry this sweepstakes has ended.'}
                    </Text>
                    {sweepsFields.closed_message ? (
                        <RenderRTE contentfulDoc={sweepsFields.closed_message} />
                    ) : (
                        <>{sweepsFields.closed_description && sweepsFields.closed_description}</>
                    )}
                </StyledContainer>
            </Grid>
        </Grid>
    );
}
